// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3sogH","image":"Header_image__1NiEF","name":"Header_name__27GwT","info":"Header_info__vaBhc","infoRow":"Header_infoRow__2yNMc"};